import { useEffect, useState } from 'react'
import { listPostCategories, type PostCategory } from '../api/postCategories'

let cache: { at: number; items: PostCategory[] } | null = null

export function usePostCategories(opts?: { enabled?: boolean }) {
  const enabled = opts?.enabled !== false
  const [items, setItems] = useState<PostCategory[] | null>(() => (cache ? cache.items : null))
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(enabled && !cache)

  useEffect(() => {
    if (!enabled) return
    let cancelled = false
    const now = Date.now()
    if (cache && now - cache.at < 5 * 60_000) {
      setItems(cache.items)
      setLoading(false)
      return
    }
    setLoading(true)
    listPostCategories()
      .then((arr) => {
        if (cancelled) return
        cache = { at: Date.now(), items: arr }
        setItems(arr)
        setError(null)
      })
      .catch((e: any) => {
        if (cancelled) return
        setError(e?.message || 'Failed to load categories')
      })
      .finally(() => {
        if (cancelled) return
        setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [enabled])

  return { items, error, loading }
}

